import {useSearchParams} from "react-router";
import {pageQueryStore, vhsCustomerStore} from "../../../store";
import {CustomerFilterAutoComplete} from "../../ui";

function VhsFilterBar() {
    const [searchParams, setSearchParams] = useSearchParams()
    const queryS = searchParams.get('q') || undefined
    const customerIdS = searchParams.get('customerId') || undefined
    const hasFilter = Boolean(queryS) || Boolean(customerIdS)

    return <div style={{
        display: 'flex',
        zoom: '85%',
        alignItems: 'flex-start',
        zIndex: 1
    }}>
        <div style={{
            minWidth: '2em',
            maxWidth: '12em',
            marginRight: '1em'
        }}>
            <CustomerFilterAutoComplete
                items={vhsCustomerStore.items}
                search={vhsCustomerStore.search}
                param={'customerId'}/>
        </div>
        <div style={{
            minWidth: '10em',
            maxWidth: '20em',
        }}>
            <button
                className={'button is-primary is-rounded'}
                disabled={!hasFilter}
                onClick={() => {
                    Array.from(searchParams.keys()).forEach(key => {
                        searchParams.delete(key)
                    })
                    setSearchParams(searchParams)
                    pageQueryStore.clear('vda')
                }}
                style={{
                    marginTop: '0.3em'
                }}
            >
                <span className={`icon is-small`}>
                    <span className="material-symbols-outlined">filter_list_off</span>
                </span>
                <span>Zurücksetzen</span>
            </button>
        </div>
    </div>
}

export {
    VhsFilterBar
}
